import axios from "axios";
import ApiService from "@/services/ApiService.js";

export const state = {
  listTocas:[],
  resultFile: [],
  tocasTotal: '',
  newToca:[],
  listTocasTotal:[]
};
export const mutations = {
  GET_TOCAS({ context }, tocas) {
    let tocas_array = [];
    Object.entries(tocas).forEach(([key, val]) => tocas_array.push(val));
    return (state.listTocas = tocas_array);
  },
  SAVE_TOCA({ context }, data) {
    state.newToca = Object.assign({}, data);
  },
  EDIT_TOCA({ context }, dataUser) {
    state.dataUser = Object.assign({}, dataUser);
  },
  GET_FILES({ context }, data) {
    state.resultFile = Object.assign({}, data);
  },
  GET_TOCAS_COUNT({ context }, data) {
    state.tocasTotal = data;
  },
  GET_TOTAL_TOCAS_COUNT({ context }, data) {
    state.listTocasTotal = data;
  },
};
export const actions = {
  GET_TOCAS({ commit }, data) {
    return new Promise((resolve, reject) => {
      commit("SET_LOADING", true);
      ApiService.get(data)
        .then(response => {
          // console.log(response.data.data);
          commit("SET_LOADING", false);
          commit("GET_TOCAS", response.data.data.tocas.data);//mandar a mutations
          resolve(response);
        })
        .catch(error => {
          commit("SET_LOADING", false);
          reject(error);
        });
    });
  },
  GET_TOTALES_POR_SALA({ commit }, data) {
    return new Promise((resolve, reject) => {
      commit("SET_LOADING", true);
      ApiService.get(data)
        .then(response => {
          commit("SET_LOADING", false);
          resolve(response);
        })
        .catch(error => {
          commit("SET_LOADING", false);
          reject(error);
        });
    });
  },
  GET_TOCAS_REPORTE({ commit }, data) {
    return new Promise((resolve, reject) => {
      commit("SET_LOADING", true);
      ApiService.get(data)
        .then(response => {
          commit("SET_LOADING", false);
          commit("GET_TOCAS", response.data.data.tocas);//mandar a mutations
          resolve(response);
        })
        .catch(error => {
          commit("SET_LOADING", false);
          reject(error);
        });
    });
  },
  SAVE_TOCA({ commit }, data) { //axios, mandar parametros para post
    return new Promise((resolve, reject) => {
      commit("SET_LOADING", true);
      ApiService.post(data)//funcion de ApiService
        .then(response => {
          commit("SET_LOADING", false);
          commit("SAVE_TOCA", response);//mandar a mutations
          resolve(response);
        })
        .catch(error => {
          commit("SET_LOADING", false);
          reject(error);
        });
    });
  },
  EDIT_TOCA({ commit }, dataUser) { //axios, mandar parametros para post
    return new Promise((resolve, reject) => {
      commit("SET_LOADING", true);
      ApiService.put(dataUser)//funcion de ApiService
        .then(response => {
          commit("SET_LOADING", false);
          commit("EDIT_MAGISTRADO", response);//mandar a mutations
          resolve(response);
        })
        .catch(error => {
          commit("SET_LOADING", false);
          reject(error);
        });
    });
  },
  DELETE_TOCA({ commit }, id) { //axios, mandar parametros para post
    return new Promise((resolve, reject) => {
      commit("SET_LOADING", true);
      ApiService.delete(id)//funcion de ApiService
        .then(response => {
          //console.log("store",response);
          commit("SET_LOADING", false);
          resolve(response);
        })
        .catch(error => {
          commit("SET_LOADING", false);
          reject(error);
        });
    });
  },
  GET_FILE({ commit }, data) {
    return new Promise((resolve, reject) => {
      commit("SET_LOADING", true);
      ApiService.getFile(data)
        .then(response => {
          commit("SET_LOADING", false);
          commit("GET_FILES", response);//mandar a mutations
          resolve(response);
        })
        .catch(error => {
          commit("SET_LOADING", false);
          reject(error);
        });
    });
  },
  GET_PDF({ commit }, data) {
    return new Promise((resolve, reject) => {
      commit("SET_LOADING", true);
      ApiService.getPdf(data)
        .then(response => {
          commit("SET_LOADING", false);
          commit("GET_FILES", response);//mandar a mutations
          resolve(response);
        })
        .catch(error => {
          commit("SET_LOADING", false);
          reject(error);
        });
    });
  },
  GET_TOCAS_COUNT({ commit }, data) {
    return new Promise((resolve, reject) => {
      commit("SET_LOADING", true);
      ApiService.get(data)
        .then(response => {
          commit("SET_LOADING", false);
          commit("GET_TOCAS_COUNT", response.data.data.tocas);//mandar a mutations
          resolve(response);
        })
        .catch(error => {
          commit("SET_LOADING", false);
          reject(error);
        });
    });
  },

  DELETE_SENTENCIA({ commit }, id) { //axios, mandar parametros para post
    return new Promise((resolve, reject) => {
      commit("SET_LOADING", true);
      ApiService.delete(id)//funcion de ApiService
        .then(response => {
          //console.log("store",response);
          commit("SET_LOADING", false);
          resolve(response);
        })
        .catch(error => {
          commit("SET_LOADING", false);
          reject(error);
        });
    });
  },

  RUN_SCRIPT_PUBLICACIONES({ commit }, data) {
    return new Promise((resolve, reject) => {
      commit("SET_LOADING", true);
      ApiService.get(data)
        .then(response => {
          //console.log("runscript",response);
          resolve(response);
        })
        .catch(error => {
          commit("SET_LOADING", false);
          //console.log("erro runscript",error);
          reject(error);
        });
    });
  },

  GET_TOTAL_TOCAS_COUNT({ commit }, data) {
    return new Promise((resolve, reject) => {
      commit("SET_LOADING", true);
      ApiService.get(data)
        .then(response => {
          commit("SET_LOADING", false);
          commit("GET_TOTAL_TOCAS_COUNT", response.data.data.total_tocas);//mandar a mutations
          resolve(response);
        })
        .catch(error => {
          commit("SET_LOADING", false);
          reject(error);
        });
    });
  },
};

export const getters = {//leer datos
  listTocas: state => state.listTocas,
  tocasTotal: state => state.tocasTotal,
  newToca: state => state.newToca,
  listTocasTotal: state => state.listTocasTotal,
};
